module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_namba-21da05990aebaa819a01c38fbe16ba45.jpg";